<template>
  <div>
    <div class="row">
      <div class="col-lg-12" v-show="true">
        <block-cntr
          :btitle="'ONT Upgrade Status'"
          style="height: 100%"
          :closeButton="false"
        >
          <!-- 按钮 -->
          <div class="form-inline" style="height: 35px">
            <span style="float: left">
              <div class="btn-group open">
                <div
                  @click="loadOntUpgradeStatus()"
                  class="btn"
                  style="padding: 0px"
                >
                  <i class="fa fa-refresh page-tableaction"></i>
                </div>
              </div>
            </span>
            <span style="margin-left: 25px; font-weight: bold"
              >Total entries: {{ total }}</span
            >
            <label style="float: right; display: flex">
              <span class="input-group-addon tablesearch-box">
                <i class="fa fa-search"></i>
              </span>
              <input
                type="search"
                v-model="searchInfo"
                class="form-control"
                :placeholder="'slot/pon/ont'"
                style="border-radius: 0px"
              />
            </label>
          </div>
          <table class="table table-hover table-noneborder-top">
            <thead>
              <tr>
                <th
                  v-for="(value, key) in ontUpgradeStatus.title"
                  :key="key"
                  :title="value"
                >
                  {{ value }}
                </th>
              </tr>
            </thead>
            <tbody style="height: 100%">
              <tr v-for="row in ontUpgradeStatusFilter" :key="row.mac">
                <td v-for="(value, key) in row" :key="key" :title="value">
                  <div>{{ value }}</div>
                </td>
              </tr>
            </tbody>
          </table>
        </block-cntr>
      </div>
    </div>
  </div>
</template>

<script>
import en from "../lang/en-US.js"
import BlockCntr from "@/components/BlockCntr.vue"
import { get, post } from "@/utils/http.js"

export default {
  name: "ontUpgradeStatus",
  data() {
    return {
      ontUpgradeStatus: "",
      searchInfo: "",
      intervalID:null,
    }
  },
  components: {
    BlockCntr,
  },
  created() {},
  beforeDestroy() {
    clearInterval(this.intervalID)
  },
  mounted() {
    this.loadOntUpgradeStatus()
    this.intervalID = window.setInterval(this.loadOntUpgradeStatus, 5000)
  },
  methods: {
    loadOntUpgradeStatus() {
      get("ontUpgradeStatus")
        .then((res) => (this.ontUpgradeStatus = res.data))
        .catch((err) => {
          this.ontUpgradeStatus = en.ontUpgradeStatus
        })
    },
  },
  computed: {
    ontUpgradeStatusFilter() {
      var statusTable = []
      var number = 0
      if (this.ontUpgradeStatus.data !== undefined)
        this.ontUpgradeStatus.data.forEach((element) => {
          if (
            this.searchInfo == "" ||
            (element["ontid"].split("/")[0] == this.searchInfo.split("/")[0] &&
              element["ontid"].split("/")[1] == this.searchInfo.split("/")[1] &&
              (element["ontid"].split("/")[2] ==
                this.searchInfo.split("/")[2] ||
                this.searchInfo.split("/")[2] == undefined))
          ) {
            statusTable.push(element)
            number += 1
          }
        })
      this.total = number
      return statusTable
    },
  },
}
</script>